__turbopack_context__.v({
  "badge": "organogram-visual-module__CjZNHW__badge",
  "badgeOn": "organogram-visual-module__CjZNHW__badgeOn",
  "badgeTraced": "organogram-visual-module__CjZNHW__badgeTraced",
  "canvas": "organogram-visual-module__CjZNHW__canvas",
  "drawing": "organogram-visual-module__CjZNHW__drawing",
  "group": "organogram-visual-module__CjZNHW__group",
  "groupBadge": "organogram-visual-module__CjZNHW__groupBadge",
  "groupOn": "organogram-visual-module__CjZNHW__groupOn",
  "holding": "organogram-visual-module__CjZNHW__holding",
  "line": "organogram-visual-module__CjZNHW__line",
  "lineOn": "organogram-visual-module__CjZNHW__lineOn",
  "lines": "organogram-visual-module__CjZNHW__lines",
  "node": "organogram-visual-module__CjZNHW__node",
  "nodeName": "organogram-visual-module__CjZNHW__nodeName",
  "nodeNr": "organogram-visual-module__CjZNHW__nodeNr",
  "nodeOn": "organogram-visual-module__CjZNHW__nodeOn",
  "nodeTraced": "organogram-visual-module__CjZNHW__nodeTraced",
  "sibling": "organogram-visual-module__CjZNHW__sibling",
  "siblingHead": "organogram-visual-module__CjZNHW__siblingHead",
  "siblingName": "organogram-visual-module__CjZNHW__siblingName",
  "siblingTraced": "organogram-visual-module__CjZNHW__siblingTraced",
  "subject": "organogram-visual-module__CjZNHW__subject",
});
